import { createClient } from '@supabase/supabase-js';

// Environment variables
// eslint-disable-next-line no-undef
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
// eslint-disable-next-line no-undef
const supabaseKey = process.env.VUE_APP_SUPABASE_ANON_KEY;
// eslint-disable-next-line no-undef
const environment = process.env.VUE_APP_ENVIRONMENT || 'development';

const normalizeSupabaseUrl = (url) => {
  if (!url) return url;
  if (typeof window === 'undefined') return url;

  try {
    const parsed = new URL(url);
    const isLoopbackTarget = parsed.hostname === '127.0.0.1' || parsed.hostname === 'localhost';
    const currentHost = window.location.hostname;
    const isCurrentHostLoopback = currentHost === '127.0.0.1' || currentHost === 'localhost';

    // When app is opened via LAN IP but Supabase URL points to loopback,
    // route requests to the same machine/IP the app was loaded from.
    if (isLoopbackTarget && !isCurrentHostLoopback) {
      parsed.hostname = currentHost;
      return parsed.toString();
    }
  } catch (error) {
    console.warn('Could not parse Supabase URL for normalization:', error);
  }

  return url;
};

const resolvedSupabaseUrl = normalizeSupabaseUrl(supabaseUrl);

// Validate environment variables
if (!resolvedSupabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables:', {
    url: resolvedSupabaseUrl ? '✓' : '✗',
    key: supabaseKey ? '✓' : '✗',
    environment
  });
  throw new Error('Supabase configuration is incomplete');
}

// Log current environment (only in development)
if (environment === 'development') {
  console.log(`🔧 Supabase connected to: ${environment} environment`);
  console.log(`📡 URL: ${resolvedSupabaseUrl}`);
}

export const supabase = createClient(resolvedSupabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
  },
});

// Export environment info for debugging
export const config = {
  environment,
  supabaseUrl: resolvedSupabaseUrl,
  // eslint-disable-next-line no-undef
  gameCode: process.env.VUE_APP_GAME_CODE || 'unknown'
};

